import React from 'react';

import { Box } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { SORT_DIRECTIONS } from '../TooltipedSortLabel.constants';

import { getIconStyles, wrapperStyles } from './SortIcon.styles';

const SingleSortIcon = ({ direction, isActive }) => (
  <Box component="span" sx={getIconStyles(isActive)}>
    <ArrowCheckIcon
      direction={direction === SORT_DIRECTIONS.DESC ? IconDirection.DOWN : IconDirection.UP}
      size={IconSize[12]}
    />
  </Box>
);

const SortIcon = ({ direction }) => {
  if (direction === SORT_DIRECTIONS.NONE) {
    return (
      <Box sx={wrapperStyles}>
        <SingleSortIcon direction={SORT_DIRECTIONS.ASC} isActive={false} />
        <SingleSortIcon direction={SORT_DIRECTIONS.DESC} isActive={false} />
      </Box>
    );
  }

  return <SingleSortIcon isActive direction={SORT_DIRECTIONS.DESC} />;
};

SortIcon.propTypes = {
  direction: PropTypes.oneOf(Object.values(SORT_DIRECTIONS)).isRequired,
};

SingleSortIcon.propTypes = {
  direction: PropTypes.oneOf([SORT_DIRECTIONS.ASC, SORT_DIRECTIONS.DESC]).isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default SortIcon;
